module.exports = __webpack_public_path__ + "static/media/ic_treasure.d4c74b98.svg";